import { render, staticRenderFns } from "./OrganizationSettingsGuard.vue?vue&type=template&id=9fd480b4&"
import script from "./OrganizationSettingsGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationSettingsGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports